import axios from "../helpers/axios";
import { IConversation, IConversations, PageableData } from "../helpers/types";
import { authService, socketService } from "./index";

type membersPayload = {
  fanId: string;
  creatorId: string;
};

class MessagesService {
  public getAllConversations(page: number, type: string) {
    return new Promise<PageableData<IConversations>>((resolve, reject) => {
      axios
        .get(`/conversations/user/${authService.getId()}?page=${page}&type=${type}`)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public getUnreadConversations(page: number, type: string) {
    return new Promise<PageableData<IConversations>>((resolve, reject) => {
      axios
        .get(`/conversations/user/Unread/${authService.getId()}?page=${page}&type=${type}`)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public getUnansweredConversations(page: number, type: string) {
    return new Promise<PageableData<IConversations>>((resolve, reject) => {
      axios
        .get(`/conversations/user/Unanswered/${authService.getId()}?page=${page}&type=${type}`)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public searchConversation({ search, page, type }: { search: string; page: number; type: string }) {
    return new Promise<PageableData<IConversations>>((resolve, reject) => {
      axios
        .get(`/conversations/user/${authService.getId()}/search?search=${search}&type=${type}&page=${page}`)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public getConversationById(conversationId: string) {
    return new Promise<IConversations>((resolve, reject) => {
      axios
        .get(`/conversations/${conversationId}`)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public getConversationMessages(conversationId: string) {
    return new Promise<IConversations>((resolve, reject) => {
      axios
        .get(`/conversations/${conversationId}`)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public isConversationExist(members: membersPayload) {
    return new Promise<IConversations>((resolve, reject) => {
      axios
        .get(`/conversations/exist/${members.fanId}/${members.creatorId}`)
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public getTotalNotReadMessages() {
    return new Promise<string | null>((resolve, reject) => {
      axios
        .get(`/conversations/stats/counting-not-read-conversations`)
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public getUnreadByTypes() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/conversations/stats/get-unread-by-types`)
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public sendMessageFromDiscover(payload: { receiverId: string; message: string }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/conversations/send-message-from-discover`, payload)
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public sendMessage(payload: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/messages/send-message`, payload, {
          headers: {
            ...socketService.getSocketIdForHeaders(),
          },
        })
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }
  public updateMessageStatus(payload: { messageId: string; action: "accepted" | "refused"; userType: string; isToDeliverMedia?: boolean }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .patch(`/messages/update-message-status`, payload)
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            resolve(response.data);
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public readAllMessages(payload: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .patch(
          `/messages/read-all-messages`,  
          { conversationId: payload },
          {
            headers: {
              ...socketService.getSocketIdForHeaders(),
            },
          }
        )
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }

  public findAllMessagesByConversationId(conversationId: string, page: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/messages/find-all-messages?conversationId=${conversationId}&page=${page}`)
        .then((response) => {
          if (response?.data?.status === 0) {
            resolve(response.data.data);
          } else if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            reject(error.response.data.message);
          } else {
            reject("Something went wrong.");
          }
        });
    });
  }
}

export const messageService = new MessagesService();